export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13955.080f4f4c.jpg";